// Generated by CoffeeScript 1.12.5
var URL, getPort, getUrl, parseServerBind, parseUseIpAddressForHttpRequests, sites;

URL = require('url-parse');


/*
mapping of Ops app URLs in each environment.
 */

sites = require('./site_list');


/*
Get url for site from siteName and environment
@param {String} siteName - chosen from list above
@param {Object|String} env
  - app settings object (pojo)
    or process.env (sub-optimal)
    or string ('development', 'test', 'staging', or 'production')
  - better-than-nothing fallback to process.env. (not good in dev; prefer `settings`, but not global.)
 */

exports.getUrl = getUrl = function(siteName, env) {
  var boundPort, envName, path, port, protocol, ref, serverBind, site, uri, url, useIpAddressForHttpRequests;
  if (env == null) {
    env = process.env;
  }
  envName = exports.parseServerEnv(env);
  site = (ref = sites[siteName]) != null ? ref[envName] : void 0;
  if (!site) {
    throw new Error("Could not find site " + siteName + " for env " + envName);
  }
  protocol = site.protocol, uri = site.uri, port = site.port, path = site.path;
  boundPort = protocol === 'http' && port ? ":" + port : '';
  if (path == null) {
    path = '';
  }
  url = protocol + "://" + uri + boundPort + path;
  useIpAddressForHttpRequests = parseUseIpAddressForHttpRequests(env);
  serverBind = parseServerBind(env);
  if (useIpAddressForHttpRequests === true && (serverBind != null)) {
    url = new URL(url);
    url.set('protocol', 'http:');
    url.set('hostname', serverBind);
    url.set('port', port);
    url = url.toString();
  }
  return url;
};


/*
Get port for site from siteName and environment
@param {String} siteName - chosen from list above
@param {Object|String} env
  - app settings object (pojo)
    or process.env (sub-optimal)
    or string ('development', 'test', 'staging', or 'production')
  - better-than-nothing fallback to process.env. (not good in dev; prefer `settings`, but not global.)
 */

exports.getPort = getPort = function(siteName, env) {
  var envName, ref;
  if (env == null) {
    env = process.env;
  }
  if (!sites.hasOwnProperty(siteName)) {
    throw new Error("Could not find site with name " + siteName);
  }
  envName = exports.parseServerEnv(env);
  return (ref = sites[siteName][envName]) != null ? ref.port : void 0;
};


/*
get all URLs for a given environment.
used for CORS, Content Security Policy, etc.
 */

exports.getAllUrls = function(env) {
  return Object.keys(sites).map(function(site) {
    return getUrl(site, env);
  });
};


/*
parse environment obj, or convict/settings pojo.
settings pojo is preferred b/c local setups don't necessarily have NODE_ENV.

prod and staging share 'production' NODE_ENV but differentiate on APP_INSTANCE.
 */

exports.parseServerEnv = function(env) {
  var envName;
  envName = null;
  if (typeof env === 'string') {
    envName = env;
  } else if (typeof env === 'object') {
    if (env.env != null) {
      envName = env.env;
    } else if (env.NODE_ENV != null) {
      envName = env.NODE_ENV;
    }
    if (env.APP_INSTANCE === 'staging' || env.appInstance === 'staging') {
      envName = 'staging';
    }
  }
  if (envName == null) {
    envName = 'development';
  }
  if (envName !== 'development' && envName !== 'test' && envName !== 'staging' && envName !== 'production') {
    throw new Error("Unrecognized environment '" + envName + "'");
  }
  return envName;
};

parseUseIpAddressForHttpRequests = function(env) {
  if (typeof env === 'string') {
    return null;
  } else if (typeof env === 'object') {
    if (env.useIpAddressForHttpRequests != null) {
      return Boolean(env.useIpAddressForHttpRequests);
    } else if (env.USE_IP_ADDRESS_FOR_HTTP_REQUESTS != null) {
      return Boolean(env.USE_IP_ADDRESS_FOR_HTTP_REQUESTS);
    }
  }
  return null;
};

parseServerBind = function(env) {
  var ref, ref1;
  if (typeof env === 'string') {
    return null;
  } else if (typeof env === 'object') {
    if (((ref = env.server) != null ? ref.bind : void 0) != null) {
      return (ref1 = env.server) != null ? ref1.bind : void 0;
    } else if (env.SERVER_BIND != null) {
      return env.SERVER_BIND;
    }
  }
  return null;
};
